<template>
  <div>
    <div style="display: flex; align-items: center; margin-bottom: 20px; margin-top: 10px; width: 100%;">
      <div style="display: flex; align-items: center; flex-grow: 1;">
        <router-view></router-view>
      </div>
      <export-components :apiFunction="exportMail" :requestData="getSearch({...sendData[activeTab]})" :option="option"
        @sendData=getSearchData></export-components>
    </div>
    <el-tabs v-model="activeTab" @tab-click="changeTab">
      <el-tab-pane v-for="(item,tabIndex) in data" :label="item.label" :name="item.name" :key="tabIndex">
        <span slot="label" v-if="item.showBadge">
          <el-badge style="margin-top: 10px;margin-bottom: 10px" :value="pageTotal[item.name] === 0 ? '':pageTotal[item.name]"
            :max="99">{{item.label}}</el-badge>
        </span>
      </el-tab-pane>
    </el-tabs>
    <w-table :columns="columns" :table-data="tableData" @rowSelection="rowSelection($event)"
      @getTableSearchSortCon="(...event) => { getTableSearchSortCon(event) }" :isPagination="true"
      :table-col-check="{isShow:true,name:'MailInfo4' + activeTab}" :key="activeTab" ref="wMyTable"
      :page="page" @pageChange="handlePagePagination" :isShowRowSelection="true">
      <div slot="operation" slot-scope="{record}">
        <el-button size="mini" type="success" v-if="record.mailFlag === 'SUBMITTED' && record.mailAuditFlag"
          @click="handleDetail(record)">邮寄</el-button>
        <el-button size="mini" type="danger" v-if="record.mailFlag === 'SUBMITTED' && record.mailAuditFlag"
          @click="handleNot(record)">取消邮寄</el-button>
        <el-button size="mini" type="primary" @click="updateCharge(record)">修改负责人</el-button>
        <el-button size="mini" type="warning"
          v-if="(record.mailingContent['contractScanningFlag'] || record.mailingContent['reportScanningFlag'] || record.mailingContent['reimbursementScanningFlag']) && !record.mailAttachment['REIMBURSEMENT_SCANNING_ANNEX'] && !record.mailAttachment['CONTRACT_SCANNING_ANNEX'] && !record.mailAttachment['REPORT_SCANNING_ANNEX'] && record.mailFlag === 'MAILED'"
          @click="handleUpload(record)">上传扫描件</el-button>
      </div>
      <div slot="contractNumbers" slot-scope="{text,record,index}">
        <ex-fold-table-cell v-if="text" :scope="{text, record, index}"></ex-fold-table-cell>
      </div>
      <div slot="mailNumbers" slot-scope="{text,record,index}">
        <ex-fold-form :scope="{time:text, index,type:'mail'}"></ex-fold-form>
      </div>
      <div slot="contactName" slot-scope="{text,record,index}">
        <ex-fold-table-cell :scope="{text:[...new Set(text)], record, index}"></ex-fold-table-cell>
      </div>
      <div slot="mailingContent" slot-scope="{text,record,index}" v-if="text">
        <el-button size="mini" type="success" @click="showContent(record)">查看邮寄内容</el-button>
      </div>
      <div slot="recipient" slot-scope="{record}">
        <span v-if="record.recipientName">{{record.recipientName + ',' + record.recipientPhone + ',' +
          record.recipientAddress}}</span>
      </div>
      <div slot="mailFlag" slot-scope="{text,record}">
        <el-tag v-if="text === 'NOT_APPLYING'" type="primary" color="white">未申请</el-tag>
        <el-tag v-else-if="text === 'SUBMITTED' && record.mailAuditFlag" type="warning"
          style="background-color: #FFFFFF">待邮寄</el-tag>
        <el-tag v-else-if="text === 'SUBMITTED' && !record.mailAuditFlag" type="warning">待审核</el-tag>
        <el-tag v-else-if="text === 'MAILED'" type="success">已邮寄</el-tag>
        <el-tag v-else-if="text === 'NOT_MAILED'" type="danger" style="background-color:#ffffff;">不邮寄</el-tag>
        <span v-else-if="text === 'CANCELED'" style="display: flex;align-items: center">
          <el-tag type="danger" color="#ffffff">
            <span>已取消</span>
          </el-tag>
          <w-ellipsis-and-look style="margin-left:5px" class="w-ellipsis-and-look" :text="record.rejectionReason"
            :column="{title:'驳回原因'}" :onlyDetail="true" :isOpenHtml="false">
          </w-ellipsis-and-look>
        </span>
        <el-tag v-else type="info">未知状态</el-tag>
      </div>
      <div slot="filterStatus" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters  }"
        style="padding: 8px; position: relative; z-index: 9999 !important;">
        <div style="padding: 15px 15px 0">
          <el-radio-group v-model="selectedKeys[0]">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='待审核'>待审核</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='待邮寄'>待邮寄</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='已邮寄'>已邮寄</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='已取消'>已取消</el-radio>
              </el-col>
            </el-row>
          </el-radio-group>
        </div>
        <div style="display: flex;padding: 15px">
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">搜索
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
          </a-button>
        </div>
      </div>
    </w-table>
    <picture-loading v-if="loading"></picture-loading>
    <mail-detail v-if="showDetailsDialog" :show-dialog="showDetailsDialog" :select-detail="showDetails"
      @submit="closeDialog">
    </mail-detail>
    <not-arrange-mail v-if="showNotMail" select-type="mail" :show-dialog="showNotMail" :select-detail="notMail"
      @submit="closeNotDialog"></not-arrange-mail>
    <upload-scanning v-if="showUpload" :select-detail="uploadInfo" :show-dialog="showUpload"
      @submit="closeUpload"></upload-scanning>
    <show-mailing-content v-if="showMailContent" :select-detail="mailingContentInfo" :show-dialog="showMailContent"
      @submit="closeShowMailInfo"></show-mailing-content>
    <update-mail-charge v-if="showMailCharge" :show-dialog="showMailCharge" :select-detail="mailChargeInfo"
      @submit="closeUpdateCharge"></update-mail-charge>
  </div>
</template>

<script>

import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import ExFoldTable from "@/components/ExFoldTable.vue";
import ExFoldTableCell from "@/components/ExFoldTableCell.vue";
import ExFoldCell from "@/components/ExFoldCell.vue";
import {attachmentMail, exportMail, getMailPage} from "@/api/dilivery/mail";
import MailDetail from "@/components/check/MailDetail.vue";
import ExFoldForm from "@/components/ExFoldForm.vue";
import {mailInfo} from "@/utils/data/tableCol/info/mail/mailInfo";
import NotArrangeMail from "@/components/mail/NotArrangeMail.vue";
import {tableOperationMixin} from "@/mixins/tableOperation";
import UploadScanning from "@/components/mail/UploadScanning.vue";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";
import ShowMailingContent from "@/components/mail/ShowMailingContent.vue";
import _ from "lodash";
import ExportComponents from "@/components/ExportComponents.vue";
import { getDataInLocalStorage } from "@/utils/localStorage";
import UpdateMailCharge from "@/components/info/mailInfo/UpdateMailCharge.vue"
const baseURL = process.env.VUE_APP_BASE_API

export default {
  name: "MailInfo",
  components: {
    ExportComponents,
    ShowMailingContent,
    PictureLoading,
    UploadScanning,
    NotArrangeMail, UpdateMailCharge,
    ExFoldForm, MailDetail, ExFoldTableCell, ExFoldCell, ExFoldTable, TableHeadNote},
  mixins: [tableOperationMixin],
  data() {
    return {
      tableData: [],
      selectable: [],
      searchConditionTag: [],
      sortConditionTag: [],
      page: { pageSize: 10, currentNum: 1, total: null },
      data: [
        { label: '全部', name: 'ALL', showBadge: false },
        { label: '待审核', name: 'AUDIT', showBadge: true },
        { label: '待邮寄', name: 'APPLYING', showBadge: true },
        { label: '已邮寄', name: 'history', showBadge: false },
        { label: '已取消', name: 'cancel', showBadge: false },
      ],
      sendData: {
        ALL: { "query#mailFlag.IN": "SUBMITTED,MAILED,CANCELED" },
        AUDIT: { "mailAuditFlag": false },
        APPLYING: { "query#mailFlag.EQ": "SUBMITTED", "mailAuditFlag": true },
        history: { "query#mailFlag.EQ": "MAILED" },
        cancel: { "query#mailFlag.EQ": "CANCELED" },
      },
      pageTotal: { ALL: 0, AUDIT: 0, APPLYING: 0, history: 0, cancel: 0 },
      activeTab: 'APPLYING',
      loading: true,
      showMailContent: false,
      mailingContentInfo: {},
      showNotMail: false,
      notMail: '',
      showMailCharge: false,
      mailChargeInfo: {},
      showUpload: false,
      uploadInfo: {},
      showDetailsDialog: false,
      showDetails: '',
      showInvoiceInfo: false,
      Details: '',
      showType: '',
      option: [
        { label: '申请时间', value: 'applicantDate' },
        { label: '创建时间', value: 'createTime' },
      ],
    }
  },
  computed: {
    columns() {
      let cols = mailInfo([] || {})
      if (['APPLYING','AUDIT'].includes(this.activeTab)) {
        return JSON.parse(JSON.stringify(cols.filter(item => !['mailNumbers'].includes(item.key))))
      } else {
        return JSON.parse(JSON.stringify(cols))
      }
    },
  },
  mounted() {
    this.loadAllTabTotals()
    this.getData()
  },
  methods: {
    exportMail,
    loadAllTabTotals() {
      Object.keys(this.sendData).forEach(tabName => {
        let sendData = { ...this.sendData[tabName] }
        getMailPage({ 'page.current': 1, 'page.size': 1 }, sendData).then(res => {
          if (res.code === 200) {
            this.$set(this.pageTotal, tabName, parseInt(res.data.total))
          }
        })
      })
    },
    updateCharge(row) {
      this.showMailCharge = true
      this.mailChargeInfo = { ...row }
    },
    closeUpdateCharge(type) {
      if (type === 'confirm') {
        this.getData()
      }
      this.showMailCharge = false
      this.mailChargeInfo = {}
    },
    getSearchData(sendData) {
      if (sendData) {
        this.searchConditionTag = this.searchConditionTag.filter(item => !this.option.map(itemA => itemA.value).includes(item.key))
        if (Object.keys(sendData).length) {
          this.searchConditionTag.push(sendData)
        }
        this.$refs.wMyTable.searchConditionTag = this.searchConditionTag;
        this.getData('search')
      }
    },
    changeTab() {
      this.$nextTick(() => {
        this.tableData = []
        this.selectable = []
        this.searchConditionTag = []
        this.sortConditionTag = []
        this.page = { pageSize: 10, currentNum: 1, total: null }
        if (this.$refs.wMyTable) {
          this.$refs.wMyTable.selectedRowKeys = []
          this.$refs.wMyTable.searchConditionTag = []
        }
        this.getData()
      })
    },
    async download(row, type) {
      try {
        let url = `${baseURL}/mail-info/attachment/${row.id}/${type}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`
        const elink = document.createElement('a')
        elink.href = url
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink);
      } catch (error) {
        console.log(error);
      }
    },
    rowSelection(selectedRows) {
      this.selectable = _.unionBy(this.selectable, selectedRows, 'id').filter(item => this.$refs.wMyTable.selectedRowKeys.includes(item.id));
    },
    showContent(row) {
      this.showMailContent = true
      this.mailingContentInfo = row
    },
    closeShowMailInfo() {
      this.$nextTick(() => {
        this.showMailContent = false
      });
      this.mailingContentInfo = {}
    },
    getTableSearchSortCon(ConditionTag) {
      this.searchConditionTag = ConditionTag[0]
      this.sortConditionTag = ConditionTag[1]
      this.getData('search')
    },
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    getData(searchFlag) {
      this.loading = true
      let params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
      }
      if (searchFlag) {
        params = { 'page.current': 1, 'page.size': 10 }
      }
      if (this.sortConditionTag && this.sortConditionTag.length > 0) {
        params["order"] = this.sortConditionTag.map(sortCondition => {
          return sortCondition.colName + "." + sortCondition.order;
        }).join(",");
      }
      let sendData = { ...this.sendData[this.activeTab] }
      if (this.searchConditionTag && this.searchConditionTag.length) {
        sendData = this.getSearch(sendData)
      }
      getMailPage(params, sendData).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.records
          this.page.currentNum = parseInt(res.data.current)
          this.page.pageSize = parseInt(res.data.size)
          this.page.total = parseInt(res.data.total)
          this.$set(this.pageTotal, this.activeTab, parseInt(res.data.total))
        }
      }).catch(error => {
        this.loading = false
        console.log(error);
      })
    },
    getSearch(sendData) {
      
      this.searchConditionTag.forEach(item => {
        let value = item.value
        if (item.key === 'mailFlag') {
          if (value === '未申请') {
            value = 'NOT_APPLYING'
          } else if (['待审核','待邮寄'].includes(value)) {
            value = 'SUBMITTED'
          } else if (value === '已邮寄') {
            value = 'MAILED'
          } else {
            value = 'CANCELED'
          }
        }
        if (['saleName','contractNumber','chargeName','contactName'].includes(item.key)) {
          sendData[item.key] = value
        } else if (this.option.map(it => it.value).includes(item.key)) {
          sendData["query#" + item.key + ".BETWEEN"] = item.value
        } else {
          if (item.key === 'mailFlag' && ['待审核','待邮寄'].includes(item.value)) {
            sendData['mailAuditFlag'] = item.value !== '待审核';
          }
          sendData["query#" + item.key + ".LIKE"] = value
        }
      })
      return sendData
    },
    handleDetail(row) {
      this.showDetails = row
      this.showDetailsDialog = true
    },
    handleUpload(row) {
      this.uploadInfo = row
      this.showUpload = true
    },
    closeUpload(type) {
      if (type === 'confirm') {
        this.getData()
      }
      this.$nextTick(() => {
        this.showUpload = false
      });
    },
    handleNot(row) {
      this.notMail = row
      this.showNotMail = true
    },
    closeDialog(type) {
      if (type === 'confirm') {
        this.getData()
      }
      this.$nextTick(() => {
        this.showDetailsDialog = false;
      });
    },
    closeNotDialog(type) {
      if (type === 'confirm') {
        this.getData()
      }
      this.$nextTick(() => {
        this.showNotMail = false
      });
    },
  }
}
</script>

<style scoped>
.status-tag-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>
